import { useEffect, useState } from "react";
import { _CashRequest, _DocumentFactory, _single } from "../../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../../theme/Component/BasicPage"
import { Singleton } from "../../../../core/services/Singleton";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { Modal } from "../../../theme/Component/Modal";
import { InputDate } from "../../../theme/Input/InputDate";
import { CashRequestItem } from "../CashResquestItems/CahsRequestItems";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { CashRequestConstantSelector } from "./CashRequestConstantSelector";
import { toast } from "react-toastify";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { RequestCashReimbursement } from "./RequestCashReimbursement/RequestCashReimbursement";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { OfficeEditor } from "../Office/OfficeEditor";
import { SelectInboxCash } from "../CashDesk/SelectInboxCash";
import { AccountEditor } from "../../../editor/AccountEditor";
import { _SignCashRequest } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { EditorSignAndApprovalPanel } from "../../../contabilidad/SignAndApprovalPanel/EditorSignAndApprovalPanel";
import { SingPanelEditor } from "../../../contabilidad/SignAndApprovalPanel/SingPanelEditor";

interface Props {
    isModal?: boolean;
    seachUser?: boolean;
}

export const CashRequest = ({ seachUser, isModal }: Props) => {


    const { lista, setLista, bean, setBean, instance, handleChange } = useDataBean(_CashRequest);
    const _docStore = useDataBean(_DocumentFactory);
    const CashRequest = useDataBean(_SignCashRequest);
    const single = Singleton.getInstance();

    const [year, setYear] = useState<number>(single.getCurrenYear());
    const [obs, setObs] = useState<string>("");
    const [state, setState] = useState<number>(2);
    const [office, setOffice] = useState<number>(NaN);
    const [cashID, setCashID] = useState<number>(NaN);
    const [documents, setDocuments] = useState<any>([]);
    const [modaldocfirma, setModaldocfirma] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modalEdit, setModalEdit] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modalItems, setModalItems] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modalPost, setModalPost] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-md", });
    const [modalDoc, setModalDoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-xl", });
    const [modalConfirm, setModalConfirm] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-sm", });

    const getLista = () => {
        instance.getCashRequestCatalogForApplicant(user ?? _single.getAccountID(), year, state).then(
            (resp) => {
                //console.log(resp)
                setLista(resp)
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }

    const createItem = () => {
        setBean({
            IDAccount: single.getAccountID(),
            RequiresAdvance: false,
        });
        setModal({ ...modal, "view": true, "name": "Crear una Solicitud de Pago por Caja Menor" })
    }

    const eliminarItem = () => {
        instance.deleteCashRequest(bean.IDCashRequest, bean.CashRequestDate).then(
            (resp) => {
                setModalConfirm({ ...modalConfirm, "view": false });
                getLista();
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }

    const updateItem = () => {
        instance.updateCashRequest(bean).then(
            (resp) => {
                setModalEdit({ ...modalEdit, "view": false })
                getLista();
            }
        ).catch(
            err => {
                console.error(err);
            }
        )
    }

    const postRequest = () => {
        instance.postCashRequest(bean.IDCashRequest, bean.CashRequestDate, bean.IDCashDeskAccount, single.getAccountID(), obs).then(
            (resp) => {
                setModalPost({ ...modalPost, "view": false })
                getPdfAccountantDocument(resp)
                setModalDoc({ ...modalDoc, "view": true, "name": "Documento Generado" })
                getLista();
                setCashID(NaN);
                setOffice(NaN)
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDCashRequest', mask: MASK_NUMBER },
        { title: 'Fecha Solicitud', property: 'CashRequestDate' },
        { title: 'Solicitado por', property: 'AccountName' },
        { title: 'Descripción', property: 'Description' },
        { title: 'Estado de la Operación', property: 'OrderStateName' },
        { title: 'Estado', property: 'StateName' },
        { title: 'Solicitante', property: 'AccountName' },
        { title: 'Requiere Anticipo', property: 'RequiresAdvance' },
        { title: 'Anticipo Solicitado', property: 'AdvanceValue', mask: MASK_MONEY },
        { title: 'Anticipo Pagado', property: 'AdvanceApprovedValue', mask: MASK_MONEY },
        { title: 'Documento', property: 'CashRequestDocument' },
        { title: 'Estado del Documento', property: 'DocStateName' },
        { title: 'Valor Rembolsado', property: 'Value', mask: MASK_MONEY },
        { title: 'Caja Solicitada', property: 'CashDeskAccountName' },
        { title: 'Responsable de Caja', property: 'IDEmployeeName' },
    ]

    const iconButtonsItem = [
        { nombre: "Agregar", visible: single.canCreate(), icono: "ri-file-add-line", evento: createItem },
    ];

    const listaBotones = () => {
        const botones = [
            // { titulo: "Editar", icono: "ri-edit-2-line", visible: (single.canEdit() && (bean.OrderState !== 3) && bean.State !== 1), evento: () => { setModalEdit({ ...modalEdit, view: true, name: "Editar" }); }, },
            { titulo: "Ver Items", icono: "ri-file-list-line", visible: (true), evento: () => { setModalItems({ ...modalItems, view: true, name: "Facturas Asginadas al Rembolso" }); }, },
            { titulo: "Editar", icono: "ri-edit-2-line", visible: (single.canEdit()), evento: () => { setModalEdit({ ...modalEdit, view: true, name: "Editar" }); }, },
            // { titulo: "Eliminar", icono: "ri-delete-bin-line", visible: (single.canDelete() && (bean.OrderState !== 3 && bean.State !== 1)), evento: () => { setModalConfirm({ ...modalConfirm, view: true, name: `Eliminar ${bean.Name}` }); }, },
            { titulo: "Eliminar", icono: "ri-delete-bin-line", visible: (single.canDelete()), evento: () => { setModalConfirm({ ...modalConfirm, view: true, name: `Eliminar ${bean.Name}` }); }, },
            // { titulo: "Enviar Solicitud para Reemsolso por Caja Menor", icono: "ri-send-plane-line", visible: bean.OrderState !== 3 && bean.State !== 1, evento: () => { setModalPost({ ...modalPost, "name": "Enviar Solicitud para Reemsolso por Caja Menor", "view": true }) }, },
            { titulo: "Enviar documento para firma", icono: "ri-file-list-line", visible: (true), evento: () => { setModaldocfirma({ ...modaldocfirma, view: true }); }, },
            { titulo: "Enviar Solicitud para Reemsolso por Caja Menor", icono: "ri-send-plane-line", visible: bean.OrderState !== 3 && bean.State !== 1, evento: () => { setModalPost({ ...modalPost, "name": "Enviar Solicitud para Reemsolso por Caja Menor", "view": true }) }, },
            { titulo: "Ver Documento", icono: "ri-eye-line", visible: bean.DocIDDocument, evento: () => { getPdfAccountantDocumentAsModal() }, },
        ];
        return <ListMenu listaBotones={botones} />;
    };

    const setRowBean = (objeto: any) => {
        setBean(objeto);
        setObs("");
    }

    const getPdfAccountantDocument = (data: any) => {
        _docStore.instance.getPdfAccountantDocument(data.IDDocument, data.Mnemonic, data.DocumentDate, _single.getAccountID()).then(
            (resp: any) => {
                setDocuments(resp.DocumentURL);
            }
        ).catch(err => toast.error(err));
    }

    const sign = () => {
        CashRequest.instance.signCashRequest(bean.IDCashRequest, bean.CashRequestDate, CashRequest.bean.IDSignAndApprovalPanel, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp)
                toast.success('Enviado para Firma')
                setModaldocfirma({ ...modaldocfirma, "view": false })
            }
        ).catch(err => toast.error(err));
    }

    const getPdfAccountantDocumentAsModal = () => {
        _docStore.instance.getPdfAccountantDocument(bean.DocIDDocument, bean.DocMnemonic, bean.DocDate, _single.getAccountID()).then(
            (resp: any) => {
                setDocuments(resp.DocumentURL);
                setModalDoc({ ...modalDoc, "name": "Documentos", "view": true })
            }
        ).catch(err => toast.error(err));
    }

    const [user, setUser] = useState<number>();

    const getComponent = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        {seachUser &&
                            <div className="col-md-4">
                                <AccountEditor idAccount={user} label="Usuario" onChange={(e) => { setUser(e.IDAccount) }} />
                            </div>
                        }
                        <div className="col-md-4">
                            <YearSelector onChange={(e) => { setYear(e) }} value={year} />
                        </div>
                        <div className="col-md-4">
                            <CashRequestConstantSelector idSelector={state} onChange={(e) => { setState(e) }} label="Estado de la Operacón" />
                        </div>
                        <div className="col-md-2 mt-4">
                            <BasicButton disable={!year && !state} eventClick={() => { getLista() }} icon="ri-search-line" children={"Buscar"} />
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={eliminarItem}>
                        {bean.Name}
                    </ModalConfirm>
                </div>
                <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} body={lista} head={head} rowSet={(e) => { setRowBean(e) }} />

                </div>
                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal}>
                        <RequestCashReimbursement onChange={() => { setModal({ ...modal, "view": false }); getLista(); }} />
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modaldocfirma} updateModal={setModaldocfirma} eventModal={sign}>
                        <>
                            <SingPanelEditor label='Flujo de Firma' idSelector={CashRequest.bean.IDSignAndApprovalPanel} onChange={(e: any) => { CashRequest.setBean({ ...CashRequest.bean, "IDSignAndApprovalPanel": e }) }} />
                        </>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalPost} updateModal={setModalPost} eventModal={postRequest} >
                        <div className="row">
                            <div className="col-12">
                                <label>Observaciones</label>
                                <textarea value={obs} name="Observations" className="form-control" onChange={(e) => { setObs(e.target.value) }} rows={4} />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalDoc} updateModal={setModalDoc}>
                        <div className="row">
                            <div className="col">
                                <DocumentViewer list={documents} />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalItems} updateModal={setModalItems}>
                        <div className="row">
                            <div className="col-md-12">
                                <CashRequestItem entry="Request" updateFunction={() => { getLista() }} idCashRequest={bean.IDCashRequest} cashRequestDate={bean.CashRequestDate} />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalEdit} updateModal={setModalEdit} eventModal={updateItem} >
                        <div className="row">
                            <div className="col-md-6">
                                <label>Fecha de la solicitud</label>
                                <InputDate name="CashRequestDate" label=" " value={bean.CashRequestDate} setDate={(e) => { setBean({ ...bean, "CashRequestDate": e }) }} notDate={!bean.CashRequestDate} />
                            </div>
                            <div className="col-md-6 d-flex align-items-center">
                                <BasicSwitch estado={bean.RequiresAdvance} eventChange={(e) => { setBean({ ...bean, "RequiresAdvance": e }) }} label="Requiere Anticipo" />
                            </div>
                            {bean.RequiresAdvance &&
                                <div className="col-md-6">
                                    <InputMoney _label="Valor a Anticipar" _value={bean.AdvanceValue} onChange={(e) => { setBean({ ...bean, "AdvanceValue": e }) }} />
                                </div>
                            }
                            <div className="col-md-6">
                                <OfficeEditor label="Ciudad" id={office} idconpany={null} onchange={(e: any) => { setOffice(e) }} />
                            </div>
                            {office &&
                                <div className="col-md-6">
                                    <SelectInboxCash city={office} idSelector={bean.IDCashDeskAccount} onChange={(e) => { setBean({ ...bean, IDCashDeskAccount: e }) }} />
                                </div>
                            }
                            <div className="col-12">
                                <label>Descripción</label>
                                <textarea value={bean.Description} name="Description" className="form-control" onChange={handleChange} rows={4} />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        )
    }



    return isModal ? (
        <>
            {getComponent()}
        </>
    )
        :
        (
            <BasicPage titulo="Solicitud de Pago por Caja Menor">
                {getComponent()}
            </BasicPage>
        )
}